/* eslint-disable lyrahealth/no-react-native-text */
import React from 'react'

import { StyleSheet, Text, View } from '@react-pdf/renderer'

import { lightThemeColors } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/theme/colors'

type ItemListPDFProps = {
  items: { title: string; details?: string[]; rightItem?: React.ReactNode }[]
  showIndividually?: boolean
}

const styles = StyleSheet.create({
  combinedListContainer: {
    borderRadius: 12,
    border: `1px solid ${lightThemeColors.borderDefault}`,
    backgroundColor: lightThemeColors.backgroundPrimary,
  },
  individualItemContainer: {
    marginTop: 12,
    padding: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: lightThemeColors.borderDefault,
    minHeight: 30,
  },
  itemContainer: {
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: lightThemeColors.borderDefault,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  lastItem: {
    borderBottomWidth: 0,
  },
  itemLeftContainer: {},
  itemTitle: {
    fontSize: 11,
    color: lightThemeColors.textPrimary,
  },
  itemDetailsContainer: {
    marginTop: 4,
  },
  itemDetails: {
    marginTop: 4,
    fontSize: 10,
    color: lightThemeColors.textSecondary,
  },
  overviewItemRight: {
    alignItems: 'flex-end',
  },
})

const ItemListPDF: React.FC<ItemListPDFProps> = ({ items, showIndividually = false }) => {
  return (
    <View style={showIndividually ? undefined : styles.combinedListContainer}>
      {items.map((item, index) => (
        <View
          key={index}
          style={
            showIndividually
              ? styles.individualItemContainer
              : [styles.itemContainer, ...(index === items.length - 1 ? [styles.lastItem] : [])]
          }
          wrap={false}
        >
          <View style={styles.itemLeftContainer}>
            <Text style={styles.itemTitle}>{item.title}</Text>
            <View style={styles.itemDetailsContainer}>
              {item.details?.map((detail, index) => (
                <Text key={index} style={styles.itemDetails}>
                  {detail}
                </Text>
              ))}
            </View>
          </View>
          {item.rightItem && <View style={styles.overviewItemRight}>{item.rightItem}</View>}
        </View>
      ))}
    </View>
  )
}

export default ItemListPDF
